/**
 * @file useUpdateSiteSettings.js
 */
import { useMutation } from "@apollo/client";
import { UPDATE_SITE_SETTINGS } from "cache/SiteSettings/mutations";
import { GET_SITE_SETTINGS } from "cache/SiteSettings/queries";

/**
 * @hook useUpdateSiteSettings
 *
 * @description Updates the singleton site settings document.
 */
const useUpdateSiteSettings = () => {
	const [updateSiteSettingsMutation, { loading, error }] = useMutation(UPDATE_SITE_SETTINGS, {
		refetchQueries: [{ query: GET_SITE_SETTINGS }],
	});

	const updateSiteSettings = async (input) => {
		try {
			const { data } = await updateSiteSettingsMutation({ variables: { input } });
			return { data: data.updateSiteSettings };
		} catch (err) {
			return { error: err };
		}
	};

	return { updateSiteSettings, loading, error };
};

export default useUpdateSiteSettings;
